import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class Blogs extends Component {
  state = {
    blogs: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllBlogs(this.state.page_no, this.state.per_page);
  }

  getAllBlogs = (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    axios
      .get(`${Constants.getUrls.getAllBlogs}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const data = resp.data.data;
          const blogs = data.docs || [];

          const pagination = {
            page: data.page,
            limit: data.limit,
            totalDocs: data.totalDocs,
            totalPages: data.totalPages,
            hasNextPage: data.hasNextPage,
            hasPrevPage: data.hasPrevPage,
            nextPage: data.nextPage,
            prevPage: data.prevPage,
          };

          this.setState({
            blogs,
            pagination,
            page_no: data.page,
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            message: resp.data?.message || "Failed to load blogs",
            loading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          notification: true,
          message: "Something went wrong!",
          loading: false,
        });
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllBlogs(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllBlogs(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    axios
      .post(Constants.deleteUrls.deleteBlog + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Blog deleted",
          },
          () => {
            this.getAllBlogs(this.state.pagination.page, this.state.per_page);
          }
        );
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Delete failed",
        });
      });
  };

  render() {
    const { blogs, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Blogs List
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right">
              <Link to="/addnewblogs">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : blogs.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Title", accessor: "title" },
                      { Header: "Poster", accessor: "poster" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: blogs.map((blog, index) => ({
                      serial: (pagination.page - 1) * pagination.limit + (index + 1),
                      title: blog.blogs_title,
                      poster: (
                        <>
                          {blog.blog_type === "video" ? (
                            <video
                              src={Constants.imageDomain + blog.blogs_poster}
                              controls
                              style={{
                                height: "100px",
                                width: "250px",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            <img
                              src={Constants.imageDomain + blog.blogs_poster}
                              style={{
                                height: "100px",
                                width: "250px",
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          )}
                        </>
                      ),

                      // ⭐ Action Icons (Edit + Delete)
                      action: (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/* Edit */}
                          <Tooltip title="Edit Blog" placement="top">
                            <Link
                              to={{
                                pathname: `/updateblogs/${blog._id}`,
                                state: { data: blog },
                              }}
                            >
                              <IconButton color="info" size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          {/* Delete */}
                          <Tooltip title="Delete Blog" placement="top">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(blog._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Blogs Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
